export default {
  userDetail: {}
}
